import React, { useEffect, useState } from "react";
import { Modal, Descriptions, Tag, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import axiosInstance from "../../services/axios";
import { API_ENDPOINTS } from "constants/api";
import { ROLES } from "constants/roles"; // Make sure this exists and contains SUPER_ADMIN
import { toTitleCase } from "utils/helperFunctions/textFormatters";
interface UserGroup {
  id: string;
  name: string;
  description: string;
}

interface ProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: any;
}

const ProfileModal: React.FC<ProfileModalProps> = ({
  isOpen,
  onClose,
  user,
}) => {
  const [userGroups, setUserGroups] = useState<UserGroup[]>([]);
  const [loading, setLoading] = useState(false);

  const isSuperAdmin =
    user?.roles &&
    user.roles.length > 0 &&
    user.roles[0].name === ROLES.SUPER_ADMIN;

  const fetchUserGroups = async () => {
    if (isSuperAdmin) {
      setUserGroups([]);
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        API_ENDPOINTS.USER_GROUPS.GET_USER_ASSIGNED_GROUP,
      );
      setUserGroups(response.data.data || []);
    } catch (error) {
      // Let axiosInstance handle error messages
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && user && !isSuperAdmin) {
      fetchUserGroups();
    }
    if (isOpen && isSuperAdmin) {
      setUserGroups([]);
    }
  }, [isOpen, user, isSuperAdmin]);

  if (!user) return null;

  return (
    <Modal
      title={
        <span>
          <UserOutlined /> Profile Information
        </span>
      }
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={450}
    >
      <Descriptions column={1}>
        {user.firstName || user.lastName ? (
          <Descriptions.Item label="Name">
            {user.firstName} {user.lastName}
          </Descriptions.Item>
        ) : null}
        <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
        <Descriptions.Item label="Role">{user.roles[0].name}</Descriptions.Item>
        {!isSuperAdmin && (
          <Descriptions.Item label="Groups">
            {loading ? (
              <Spin size="small" />
            ) : userGroups.length > 0 ? (
              <div className="flex flex-wrap gap-1">
                {userGroups.map((group) => (
                  <Tag key={group.id} color="blue">
                    {toTitleCase(group.name)}
                  </Tag>
                ))}
              </div>
            ) : (
              <span className="text-gray-500">No groups assigned</span>
            )}
          </Descriptions.Item>
        )}
      </Descriptions>
    </Modal>
  );
};

export default ProfileModal;
